<ng-container *ngIf="validation === activeValidation"><ng-content></ng-content></ng-container>